// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"14888a97","245":"9a8864ed","293":"f336f6ce","666":"d100bc4c","731":"c7eaa6ac","744":"2d2cabb4","896":"35e13f22","904":"633837d1"}[chunkId] + ".chunk.js";
};